<template>
  <a href="#threads" id="threadsActivator" class="ion-chatbubble" style="margin-right:10px;">
    <span class="label">Chats</span>
    <span v-if="pendingCount>0" class="badge">{{pendingCount}}</span>
  </a>
</template>
<script>
import { db } from '@/firebase';

export default {
  name: 'HeaderButton',
  data() {
    return {
      allCount:0,
      pendingCount:0
    }
  },
  methods: {},
  async created(){
    let vm = this;
    let userRecord = await db.collection('/users').doc(vm.$config.FROM.id.toString()).get()
    if(userRecord.exists){
      let userData = userRecord.data();
      if(userData.pending){
        vm.pendingCount=Object.keys(userData.pending).length;
      }
    }

  },
  mounted(){
    let vm = this;
    db.collection('/users').doc(vm.$config.FROM.id.toString()).onSnapshot(function(doc) {
      console.log(doc);
      console.log(doc.data());
      let data = doc.data();
      if(data.pending){
        vm.pendingCount=Object.keys(data.pending).length;
      }
    });
  }
}
</script>
